__webpack_require__.p = "https://static.age.awaze.com/landing-pages-mfe/d2d3161/_next/";